module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-light-webfont.54876703.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-light-webfont.svg
// module id = 366
// module chunks = 3